<template lang="pug">
.form-frame
  .title.mb-3 {{ title }}
  page-loading(v-if="fetching")
  template(v-else)
    slot
    FormActions(:loading="loading"
      @cancel="$emit('cancel')"
      @submit="submit") {{ message }}
    v-dialog(v-model="dialog"
      max-width="500"
      persistent)
      v-card.text-xs-center
        v-card-title.title
          v-spacer
          p {{ successMessage }}
          v-spacer
        v-card-actions.text-xs-center
          v-spacer
          v-btn(color="success"
            flat
            outline
            @click="succeedConfirm") 確認
          v-spacer
</template>

<script>
import { mapActions } from "vuex";
import PageLoading from "@/components/core/PageLoading.vue";
import FormActions from "@/components/core/FormActions.vue";

export default {
  name: "FormFrame",
  components: {
    PageLoading,
    FormActions
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    fetching: {
      type: Boolean,
      default: false
    },
    fn: {
      type: Function,
      default: () => {}
    },
    successMessage: {
      type: String,
      default: "資料已更新"
    }
  },
  data() {
    return {
      message: "",
      loading: false,
      dialog: false
    };
  },
  watch: {
    message(v) {
      this.$emit("message", v);
    },
    loading(v) {
      this.$emit("loading", v);
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      this.message = "";

      try {
        const res = await this.fn();
        if (!res) return (this.loading = false);
        const data = this.$utils.parseResponse(res);
        this.$emit("submit-succeed", data);
        this.loading = false;
        this.dialog = true;
        return { succeed: true, data };
      } catch (e) {
        console.log(e);
        const data = this.$utils.parseResponse(e);
        this.message = data;
        this.loading = false;
        this.$emit("submit-fail", data);
        return { succeed: false, data };
      }
    },
    succeedConfirm() {
      this.dialog = false;
      this.$emit("succeed-confirm");
    }
  }
};
</script>
